export default "__VITE_ASSET__v5AHX32W__"